import { createCrudSlice } from '../createCrudSlice';
import newsService from '@/services/news.service';

const { reducer, thunks } = createCrudSlice('news', newsService);
export const { fetchList: fetchNews, createItem: createNews, updateItem: updateNews, deleteItem: deleteNews } = thunks;
export default reducer;
